import moment from 'moment-timezone';

function formatTimestampToFullDate(timestampInSeconds, timezone = 'America/New_York') {
  return moment(timestampInSeconds * 1000).tz(timezone).format('MMM D, YYYY, h:mm A');
}

function formatUnixTimestampToDateObject(timestamp) {
  return moment.unix(timestamp).toDate();
}

function formatTimeDifferenceToDisplayDuration(timestamp1, timestamp2) {
  const moment1 = moment.unix(timestamp1);
  const moment2 = moment.unix(timestamp2);
  const diff = moment2.diff(moment1);
  const duration = moment.duration(diff);
  const humanizedDuration = duration.humanize(false).replace(/in\s+/, '');
  if (!humanizedDuration.includes('seconds')) {
    const formattedDuration = humanizedDuration.startsWith('a ') ? humanizedDuration.replace('a ', '1 ') : humanizedDuration;
    return formattedDuration.startsWith('an ') ? humanizedDuration.replace('an ', '1 ') : formattedDuration;
  }
  return humanizedDuration;
}

const formatDynamicDateDisplay = (dateToFormat, comparisonDate, timezone = 'UTC') => {
  const format1 = 'MMM D, YYYY, h:mm A';
  const format2 = 'MMM D h:mm A';
  const format3 = 'h:mm A';

  const momentDate = moment.tz(dateToFormat * 1000, timezone);
  const momentComparisonDate = moment.tz(comparisonDate * 1000, timezone);

  if (momentDate.isSame(momentComparisonDate, 'day')) {
    return momentDate.format(format3);
  } if (momentDate.isSame(momentComparisonDate, 'year')) {
    return momentDate.format(format2);
  }
  return momentDate.format(format1);
};

export {
  formatTimestampToFullDate,
  formatTimeDifferenceToDisplayDuration,
  formatDynamicDateDisplay,
  formatUnixTimestampToDateObject,
};
